<template>
    <div class="account-box">
        <div class="account">
            <a @click="backToEdit" class="close">
                <i class="el-icon-close"></i>
            </a>
            <template v-if="type=='editInfo'">
                <div class="flex-box" v-if="true">
                    <div class="input-box" >
                        <div class="form-label">First Name</div>
                        <div class="form-input" >
                            <input type="text" v-model="userInfo.firstName" placeholder="First Name">
                        </div>
                    </div>
                    <div class="input-box" >
                        <div class="form-label">Last Name</div>
                        <div class="form-input" >
                            <input type="text" v-model="userInfo.lastName" placeholder="Last Name">
                        </div>
                    </div>
                </div>
                <div class="form-label">Nick Name</div>
                <div class="form-input" >
                    <input type="text" v-model="userInfo.nickName" placeholder="Please enter your name">
                </div>
                <div class="form-label">Email</div>
                <div class="form-input" >
                    <input type="text" v-model="userInfo.emailAddress" placeholder="Please enter your email">
                </div>
                <div class="form-label">Phone Number</div>
                <div class="form-input phone-input-container" style="cursor: pointer;" @click="editPhone">
                    <input type="text" v-model="userInfo.mobilePhone" disabled placeholder="Please enter your phone number">
                    <div class="edit-phone-btn">
                        <i class="el-icon-edit"></i>
                        <span>Edit</span>
                    </div>
                </div>
                <div class="form-label">Password</div>
                <div class="form-input password-input-container" style="cursor: pointer;" @click="editPassword">
                    <input type="password" value="••••••••" disabled placeholder="Password">
                    <div class="change-password-btn">
                        <i class="el-icon-edit"></i>
                        <span>Change</span>
                    </div>
                </div>
            </template>
            <template v-if="type=='bindPhone'">
                <BindPhone 
                    :fromPage="'account'"
                    @bindSuccess="handleBindSuccess"
                />
            </template>
            
            <div class="button-box" v-if="type == 'editInfo'">
                <div class="btn flex-col-center" @click="submit">
                    <i class="el-icon-loading" v-if="loading"></i>
                    <span v-else>Save</span>
                </div>
            </div>
        </div>


        <!-- 修改密码弹窗 -->
        <ForgotPassword 
            v-if="showForgotPassword"
            @close="showForgotPassword = false"
        ></ForgotPassword>

    </div>
</template>

<script>
import ForgotPassword from '@/components/ForgotPassword.vue';
import BindPhone from '@/components/BindPhone.vue';
import { postGateway } from '@/request';
export default {
    data() {
        return {
            loading: false,
            type: 'editInfo',
            userInfo: {
                contactPhone: '',
                emailAddress: '',
                nickName: '',
                firstName: '',
                lastName: ''
            },
            showForgotPassword: false,
        }
    },
    components: {
        ForgotPassword,
        BindPhone
    },
    computed: {
        isMobile() {
            return window.innerWidth < 950
        }
    },
    mounted() {
        this.getData();
    },
    methods: {
        backToEdit() {
            if(this.isMobile) {
                this.$router.go(-1)
                return
            }
            this.type = 'editInfo';
            this.getData();
        },
        editPhone() {
            this.type = 'bindPhone';
        },
        editPassword() {
            this.showForgotPassword = true;
        },
        handleBindSuccess() {
            this.type = 'editInfo';
            this.getData();
            this.$message.success('success');
        },
        getData() {
            postGateway({
                url: '/customerApp/center/getDetail',
                method: 'GET',
                data: {
                    clientId: localStorage.getItem('clientId')
                }
            }).then(res=>{
                this.userInfo = res.data;
                this.loading = false;  
            })
            .catch(err=>{
                this.$message.error(err.msg)
                this.loading = false;  
            })
        },
        submit() {
            this.loading = true;  
            let {avatar,nickName,emailAddress,contactPhone} = this.userInfo;
			
			console.log(avatar,'头像地址', contactPhone)
			
			if(!emailAddress.trim()) {
				this.$message.toast('Check your Email');
				return
			}
			let nameArr = nickName.split(' ')
            console.log(nameArr[0], 'nameArr')
			let param = {
				clientId: localStorage.getItem('clientId'),
				avatar,nickName,
                emailAddress:emailAddress.trim(),
                contactPhone,
                firstName: this.userInfo.firstName?this.userInfo.firstName:nameArr[0],
                lastName: this.userInfo.lastName?this.userInfo.lastName:(nameArr.length>1?nameArr[1]:''),
			}
            postGateway({
                url: '/customer/atClient/savePersonalInfo',
                method: 'POST',
                data: param
            }).then(()=>{
                this.getData();
                this.$message.success('Success')
            })
            .catch(err=>{
                this.getData();
                this.$message.error(err.msg)
            })
        }
    }
}
</script>

<style lang="scss" scoped>
$mainColor: #aa0bc0;
$greenColor: #09CA6A;

.account-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 30px;
    // border-radius: 6px;
    border-radius: 30px;
    // box-shadow: 0px 2px 12px rgba(16, 16, 16, 0.08);
    position: relative;
    background: #ffffff;
}
.account {
    padding: 80px 0 120px;
    .close {
      position: absolute;
      right: 100px;
      cursor: pointer;
      .el-icon-close {
        font-size: 20px;
        font-weight: bold;
      }
    }
    .flex-box {
        display: flex;
        .input-box {
            // flex: 1;
            margin-right: 10px;
            width: 200px;
            input {
                width: 100%;
                border-radius: 25px;
                background: #fafafa;
            }
        }
    }
    .title {
        padding-top: 40px;
        font-weight: 600;
        font-size: 24px;
        color: $mainColor;
        text-align: center;
    }
    .form-label {
        color: #000;
        font-size: 18px;
        font-weight: 700;
        margin: 10px 0;
    }
    .form-input {
        display: flex;
        height: 49px;
        font-size: 18px;
        margin: 10px 0 30px;
        .phone-btn-box {
            box-shadow: 0px 2px 12px rgba(16, 16, 16, 0.08);
            background-color: #fff;
            margin-right: 20px;
            border-radius: 6px;
        }

        input {
            height: 100%;
            // background-color: #fff;
            // border: 1px solid #EDEDED;
            // box-shadow: 0px 2px 12px rgba(16, 16, 16, 0.08);
            // border-radius: 12px;
            font-size: 18px;
            width: 400px;
            padding-left: 20px;    
            border-radius: 25px;
            background: #f5f5f5;
        }
    }
    
    .phone-input-container {
        position: relative;
        
        .edit-phone-btn {
            position: absolute;
            right: 26px;
            top: 50%;
            transform: translateY(-50%);
            display: flex;
            align-items: center;
            gap: 5px;
            background: $greenColor;
            color: white;
            padding: 8px 12px;
            border-radius: 20px;
            font-size: 14px;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.3s ease;
            box-shadow: 0 2px 8px rgba(9, 202, 106, 0.3);
            
            &:hover {
                background: #07bb61;
                transform: translateY(-50%) scale(1.05);
                box-shadow: 0 4px 12px rgba(9, 202, 106, 0.4);
            }
            
            i {
                font-size: 12px;
            }
        }
    }
    
    .password-input-container {
        position: relative;
        
        .change-password-btn {
            position: absolute;
            right: 26px;
            top: 50%;
            transform: translateY(-50%);
            display: flex;
            align-items: center;
            gap: 5px;
            background: $greenColor;
            color: white;
            padding: 8px 12px;
            border-radius: 20px;
            font-size: 14px;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.3s ease;
            box-shadow: 0 2px 8px rgba(9, 202, 106, 0.3);
            
            &:hover {
                background: #07bb61;
                transform: translateY(-50%) scale(1.05);
                box-shadow: 0 4px 12px rgba(9, 202, 106, 0.4);
            }
            
            i {
                font-size: 12px;
            }
        }
    }
    
    .button-box {
        display: flex;
        justify-content: flex-start;
        margin-top: 40px;

        .btn {
            height: 54px;
            min-width: 140px;
            background-color: $greenColor;
            color: #fff;
            font-size: 20px;
            padding: 0 20px;
            font-weight: 600;
            border-radius: 30px;
            transition: all 0.2s ease-in-out;
            cursor: pointer;

            &:hover {
                background-color: #07bb61;
            }
        }
    }
}
@media screen and (max-width: 950px) {
    .account-box {
        margin: 15px;
        align-items: unset;
        .account {
            padding: 25px 15px 15px;
            .close {
                right: 10px;
                top: 10px;
            }
            .button-box {
                justify-content: flex-end;
            }
            .form-label {
                font-size: 16px;
            }
            .form-input  {
                font-size: 16px;
                input {
                    font-size: 16px;
                }
            }
            
            
            .phone-input-container {
                .edit-phone-btn {
                    right: 15px;
                    padding: 6px 10px;
                    font-size: 12px;
                    
                    i {
                        font-size: 10px;
                    }
                }
            }
            
            .password-input-container {
                .change-password-btn {
                    padding: 6px 10px;
                    font-size: 12px;
                    right: 15px;
                    
                    i {
                        font-size: 10px;
                    }
                }
            }
            
        }
    }
}
</style>